import type { FaireProductEntity } from "../../entity_types/product";

export const p_6py347pmkf: FaireProductEntity = {
  token: "p_6py347pmkf",
  type: "product",
  name: "Patterned V-Neck Boho Dress",
  brandToken: "b_ysnwrcjujg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c1990047256192ed71671f8689cbbe086f72738bd66551edf4af2bc43d1e38c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f040cf5405f1c029806b6d50c528624056435799f493ce9926f1bc635170d83b.jpeg",
    "https://cdn.faire.com/fastly/28068ef30204d9a89a484af135dfa23ca671fccb2dcbe1c6def7fbb2f006ab0c.jpeg",
    "https://cdn.faire.com/fastly/987cafb16457665cb5b429dffeda73656a487faa2bbf910cdd7b98f035635027.jpeg",
    "https://cdn.faire.com/fastly/963111a99136de3a05dce275ccc274161038f1a2a75b0590be8a0dd41a224236.jpeg",
  ],
  priceDollars: 24.75,
  description:
    "Your new casual favorite features an elegant V-neck and intricate patterns. Perfect for effortlessly chic style on any occasion.\n\nFabric: 100% polyester\n\nWeight: 0.88 lb\n",
  tags: [],
  msrpDollars: 49.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:33.316Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
